<template>
  <div class="hello">
<!--    水平布局-->
    <div class="box flex-row">
      <div class="item1"></div> <!-- 黄 -->
      <div class="item2"></div> <!-- 红 -->
      <div class="item3"></div> <!-- 红 -->
    </div>
    <!--    垂直布局-->
    <div class="box1 flex-col">
      <div class="item1"></div> <!-- 黄 -->
      <div class="item2"></div> <!-- 红 -->
      <div class="item3"></div> <!-- 红 -->
    </div>
    <!--    两边布局-->
    <div class="box2 justify-between">
      <div class="item1"></div> <!-- 黄 -->
      <div class="item2"></div> <!-- 红 -->
      <div class="item3"></div> <!-- 红 -->
    </div>
    <!--    居中排列-->
    <div class="box3 flex-center">
      <div class="item1"></div> <!-- 黄 -->
      <div class="item2"></div> <!-- 红 -->
      <div class="item3"></div> <!-- 红 -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'HelloWorld',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .box {
    width: 700px;
    background-color: green;
  }
  .box1 {
    width: 700px;
    background-color: black;
  }
  .box2 {
    width: 700px;
    background-color: gray;
  }
  .box3 {
    width: 700px;
    background-color: white;
  }
  .item1{
    width: 200px;
    height: 300px;
    background:yellow;
  }
  .item2{
    width: 200px;
    height: 300px;
    background:red;
  }
  .item3{
    width: 200px;
    height: 300px;
    background:blue;
  }
  /*水平布局控件*/
  .flex-row {
    display: flex;
    flex-direction: row;
  }
  /*垂直布局控件*/
  .flex-col {
    display: flex;
    flex-direction: column;
  }
  /*两边布局*/
  .justify-between {
    display: flex;
    justify-content: space-between;
  }
  /*居中排列*/
  .flex-center {
    display:flex;
    justify-content:center;
    align-items:center;
  }
</style>



// WEBPACK FOOTER //
// src/components/test/Test.vue